import React from 'react';
import styled from 'styled-components';

// Styled Components
const ContactSection = styled.section`
  background: white;
  padding: 4rem 0 var(--section-padding-bottom) 0;
  margin-top: var(--section-push-up);
  margin-bottom: 0;
  position: relative;
  overflow: hidden;
  isolation: isolate;
`;

const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 3rem;
  color: #333;
  position: relative;
  font-family: var(--font-heading);
  font-weight: 700;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    border-radius: 2px;
  }
`;

const ContactContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
  text-align: center;
`;

const ContactDescription = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #555;
  font-family: var(--font-body);
  line-height: 1.6;
`;

const ContactInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const ContactItem = styled.div`
  background: #f8fafc;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  }

  i {
    font-size: 2.5rem;
    color: #667eea;
    margin-bottom: 1rem;
    display: block;
  }

  h3 {
    font-family: var(--font-heading);
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    margin: 0;
  }

  a {
    color: #667eea;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    font-family: var(--font-body);

    &:hover {
      color: #764ba2;
      text-decoration: underline;
    }
  }
`;

const Contact = () => {
  return (
    <ContactSection id="contact">
      <SectionTitle>Kontakt</SectionTitle>
      <ContactContainer>
        <ContactDescription>
          Interessiert an einer Zusammenarbeit? Ich freue mich auf Ihre Nachricht!
        </ContactDescription>
        <ContactInfo>
          <ContactItem>
            <i className="fas fa-envelope"></i>
            <h3>E-Mail</h3>
            <p>
              <a href="mailto:nici-frischer@live.de">
                nici-frischer@live.de
              </a>
            </p>
          </ContactItem>
          <ContactItem>
            <i className="fab fa-linkedin"></i>
            <h3>LinkedIn</h3>
            <p>
              <a href="https://linkedin.com/in/nicolette-rudmann" target="_blank" rel="noopener noreferrer">
                linkedin.com/in/nicolette-rudmann
              </a>
            </p>
          </ContactItem>
        </ContactInfo>
      </ContactContainer>
    </ContactSection>
  );
};

export default Contact; 